// deps
import { useContext, useEffect } from "react";

// internal-deps
import { CheckoutRoute, DineoutCheckoutRoute } from "@swiggy-private/checkout-types";

// contexts
import { HardwareBackContext } from "@checkout-core/contexts/HardwareBackContext";

export const useCustomHardwareBack = (
    routesToEnable: (CheckoutRoute | DineoutCheckoutRoute)[],
    customBackFn: VoidFunction,
): void => {
    const { state: hardwareBackState, setState: setHardwareBackState } = useContext(HardwareBackContext);
    useEffect(() => {
        if (hardwareBackState.shouldHandle && routesToEnable.some(route => route === hardwareBackState.activeRoute)) {
            customBackFn();
            setHardwareBackState({
                shouldHandle: false,
                activeRoute: "",
            });
        }
    }, [
        customBackFn,
        hardwareBackState.activeRoute,
        hardwareBackState.shouldHandle,
        routesToEnable,
        setHardwareBackState,
    ]);
};
